module.exports = "/fonts/NeoSansStd-Regular.woff2?92b0533eb8235b2b6cec22905e74317e";